import styled from "styled-components";

export const DPwrapperTree = styled.section`
  width: 762px;
  height: 600px;
  background-color: #fff;
  border-radius: 7px;
  overflow: hidden;
`;

export const DPwrapperTreeHeader = styled.article`
  width: 762px;
  min-height: 44px;
  height: auto;
  border-bottom: 1px solid #d9d9d9;
  font-size: 18px;
  font-weight: 700;
  color: #303030;
  padding: 10px 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
`;

export const DPwrapperTreeBodyL = styled.section`
  width: 293px;
  height: calc(100% - 44px);
  border-right: 1px solid #d9d9d9;
  float: left;
  background-color: #f5f5f5;
`;

export const DPwrapperTreeBodyR = styled.section`
  width: 469px;
  float: right;
  height: calc(100% - 44px);
  padding: 15px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const DPwrapperTreeBodyRTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
`;

export const DPwrapperTreeBodyRUL = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 10px;
  flex: 1 1 auto;
  overflow-y: auto;
`;

export const DPwrapperTreeBodyRLI = styled.li`
  width: 100%;
  height: 30px;
  position: relative;
`;
